// Theme configurations for 15 different card designs
// export interface CardTheme {
//   id: string;
//   name: string;
//   category: 'minimal' | 'gradient' | 'glassmorphism' | 'corporate' | 'creative' | 'premium';
//   mode: 'light' | 'dark';
//   colors: {
//     primary: string;
//     secondary: string;
//     accent?: string;
//     background: string;
//     text: string;
//     textSecondary: string;
//     buttonBg: string;
//     buttonText: string;
//     cardBg: string;
//     border: string;
//   };
//   fonts: {
//     heading: string;
//     body: string;
//   };
//   styles: {
//     cardRadius: string;
//     buttonRadius: string;
//     buttonStyle: 'solid' | 'outline' | 'gradient';
//     backgroundPattern?: string;
//   };
// }



export const cardThemes = [
  {
    id: 'minimal-light',
    name: 'Minimal Light',
    category: 'minimal',
    mode: 'light',
    colors: {
      primary: '#1A1D2E',
      secondary: '#4F46E5',
      background: '#FFFFFF',
      text: '#1A1D2E',
      textSecondary: '#6B7280',
      buttonBg: '#1A1D2E',
      buttonText: '#FFFFFF',
      cardBg: '#FFFFFF',
      border: '#E5E7EB',
    },
    fonts: {
      heading: 'font-sans',
      body: 'font-sans',
    },
    styles: {
      cardRadius: '16px',
      buttonRadius: '8px',
      buttonStyle: 'solid',
    },
  },
  {
    id: 'minimal-dark',
    name: 'Minimal Dark',
    category: 'minimal',
    mode: 'dark',
    colors: {
      primary: '#E5E7EB',
      secondary: '#818CF8',
      background: '#0B0F1A',
      text: '#E5E7EB',
      textSecondary: '#94A3B8',
      buttonBg: '#E5E7EB',
      buttonText: '#0B0F1A',
      cardBg: '#121826',
      border: '#1E293B',
    },
    fonts: {
      heading: 'font-sans',
      body: 'font-sans',
    },
    styles: {
      cardRadius: '16px',
      buttonRadius: '8px',
      buttonStyle: 'solid',
    },
  },
  {
    id: 'gradient-blue',
    name: 'Ocean Gradient',
    category: 'gradient',
    mode: 'dark',
    colors: {
      primary: '#FFFFFF',
      secondary: '#06B6D4',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      text: '#FFFFFF',
      textSecondary: '#E0E7FF',
      buttonBg: '#FFFFFF',
      buttonText: '#667eea',
      cardBg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      border: 'rgba(255,255,255,0.2)',
    },
    fonts: {
      heading: 'font-sans',
      body: 'font-sans',
    },
    styles: {
      cardRadius: '24px',
      buttonRadius: '12px',
      buttonStyle: 'solid',
    },
  },
  {
    id: 'gradient-sunset',
    name: 'Sunset Gradient',
    category: 'gradient',
    mode: 'dark',
    colors: {
      primary: '#FFFFFF',
      secondary: '#F59E0B',
      background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      text: '#FFFFFF',
      textSecondary: '#FEF3C7',
      buttonBg: '#FFFFFF',
      buttonText: '#f5576c',
      cardBg: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      border: 'rgba(255,255,255,0.2)',
    },
    fonts: {
      heading: 'font-sans',
      body: 'font-sans',
    },
    styles: {
      cardRadius: '24px',
      buttonRadius: '12px',
      buttonStyle: 'solid',
    },
  },
  {
    id: 'gradient-forest',
    name: 'Forest Gradient',
    category: 'gradient',
    mode: 'dark',
    colors: {
      primary: '#FFFFFF',
      secondary: '#10B981',
      background: 'linear-gradient(135deg, #134e5e 0%, #71b280 100%)',
      text: '#FFFFFF',
      textSecondary: '#D1FAE5',
      buttonBg: '#FFFFFF',
      buttonText: '#134e5e',
      cardBg: 'linear-gradient(135deg, #134e5e 0%, #71b280 100%)',
      border: 'rgba(255,255,255,0.2)',
    },
    fonts: {
      heading: 'font-sans',
      body: 'font-sans',
    },
    styles: {
      cardRadius: '24px',
      buttonRadius: '12px',
      buttonStyle: 'solid',
    },
  },
  {
    id: 'glass-light',
    name: 'Glass Light',
    category: 'glassmorphism',
    mode: 'light',
    colors: {
      primary: '#1A1D2E',
      secondary: '#4F46E5',
      background: 'linear-gradient(135deg, #E0E7FF 0%, #FEF3C7 100%)',
      text: '#1A1D2E',
      textSecondary: '#4B5563',
      buttonBg: 'rgba(255,255,255,0.8)',
      buttonText: '#1A1D2E',
      cardBg: 'rgba(255,255,255,0.7)',
      border: 'rgba(255,255,255,0.3)',
    },
    fonts: {
      heading: 'font-sans',
      body: 'font-sans',
    },
    styles: {
      cardRadius: '20px',
      buttonRadius: '12px',
      buttonStyle: 'solid',
      backgroundPattern: 'backdrop-blur-xl',
    },
  },
  {
    id: 'glass-dark',
    name: 'Glass Dark',
    category: 'glassmorphism',
    mode: 'dark',
    colors: {
      primary: '#E5E7EB',
      secondary: '#818CF8',
      background: 'linear-gradient(135deg, #1E293B 0%, #334155 100%)',
      text: '#E5E7EB',
      textSecondary: '#94A3B8',
      buttonBg: 'rgba(255,255,255,0.1)',
      buttonText: '#E5E7EB',
      cardBg: 'rgba(30,41,59,0.7)',
      border: 'rgba(255,255,255,0.1)',
    },
    fonts: {
      heading: 'font-sans',
      body: 'font-sans',
    },
    styles: {
      cardRadius: '20px',
      buttonRadius: '12px',
      buttonStyle: 'solid',
      backgroundPattern: 'backdrop-blur-xl',
    },
  },
  {
    id: 'glass-purple',
    name: 'Glass Purple',
    category: 'glassmorphism',
    mode: 'dark',
    colors: {
      primary: '#FFFFFF',
      secondary: '#A78BFA',
      background: 'linear-gradient(135deg, #4C1D95 0%, #7C3AED 100%)',
      text: '#FFFFFF',
      textSecondary: '#DDD6FE',
      buttonBg: 'rgba(255,255,255,0.2)',
      buttonText: '#FFFFFF',
      cardBg: 'rgba(124,58,237,0.3)',
      border: 'rgba(255,255,255,0.2)',
    },
    fonts: {
      heading: 'font-sans',
      body: 'font-sans',
    },
    styles: {
      cardRadius: '20px',
      buttonRadius: '12px',
      buttonStyle: 'solid',
      backgroundPattern: 'backdrop-blur-xl',
    },
  },
  {
    id: 'corporate-blue',
    name: 'Corporate Blue',
    category: 'corporate',
    mode: 'light',
    colors: {
      primary: '#1E40AF',
      secondary: '#3B82F6',
      background: '#F3F4F6',
      text: '#1F2937',
      textSecondary: '#6B7280',
      buttonBg: '#1E40AF',
      buttonText: '#FFFFFF',
      cardBg: '#FFFFFF',
      border: '#E5E7EB',
    },
    fonts: {
      heading: 'font-serif',
      body: 'font-sans',
    },
    styles: {
      cardRadius: '12px',
      buttonRadius: '8px',
      buttonStyle: 'solid',
    },
  },
  {
    id: 'corporate-navy',
    name: 'Corporate Navy',
    category: 'corporate',
    mode: 'light',
    colors: {
      primary: '#1E3A8A',
      secondary: '#2563EB',
      background: '#FFFFFF',
      text: '#1E3A8A',
      textSecondary: '#475569',
      buttonBg: '#1E3A8A',
      buttonText: '#FFFFFF',
      cardBg: '#FFFFFF',
      border: '#CBD5E1',
    },
    fonts: {
      heading: 'font-serif',
      body: 'font-sans',
    },
    styles: {
      cardRadius: '12px',
      buttonRadius: '8px',
      buttonStyle: 'solid',
    },
  },
  {
    id: 'corporate-emerald',
    name: 'Corporate Emerald',
    category: 'corporate',
    mode: 'light',
    colors: {
      primary: '#065F46',
      secondary: '#10B981',
      background: '#F9FAFB',
      text: '#065F46',
      textSecondary: '#6B7280',
      buttonBg: '#065F46',
      buttonText: '#FFFFFF',
      cardBg: '#FFFFFF',
      border: '#D1D5DB',
    },
    fonts: {
      heading: 'font-serif',
      body: 'font-sans',
    },
    styles: {
      cardRadius: '12px',
      buttonRadius: '8px',
      buttonStyle: 'solid',
    },
  },
  {
    id: 'creative-neon',
    name: 'Neon Creative',
    category: 'creative',
    mode: 'dark',
    colors: {
      primary: '#FF00FF',
      secondary: '#00FFFF',
      background: '#000000',
      text: '#FFFFFF',
      textSecondary: '#A0AEC0',
      buttonBg: 'linear-gradient(90deg, #FF00FF 0%, #00FFFF 100%)',
      buttonText: '#000000',
      cardBg: '#0A0A0A',
      border: '#FF00FF',
    },
    fonts: {
      heading: 'font-sans',
      body: 'font-sans',
    },
    styles: {
      cardRadius: '16px',
      buttonRadius: '24px',
      buttonStyle: 'gradient',
    },
  },
  {
    id: 'creative-vibrant',
    name: 'Vibrant Creative',
    category: 'creative',
    mode: 'light',
    colors: {
      primary: '#EC4899',
      secondary: '#8B5CF6',
      background: 'linear-gradient(135deg, #FEF3C7 0%, #FEE2E2 50%, #DBEAFE 100%)',
      text: '#1F2937',
      textSecondary: '#6B7280',
      buttonBg: 'linear-gradient(90deg, #EC4899 0%, #8B5CF6 100%)',
      buttonText: '#FFFFFF',
      cardBg: '#FFFFFF',
      border: '#EC4899',
    },
    fonts: {
      heading: 'font-sans',
      body: 'font-sans',
    },
    styles: {
      cardRadius: '20px',
      buttonRadius: '16px',
      buttonStyle: 'gradient',
    },
  },
  {
    id: 'creative-retro',
    name: 'Retro Wave',
    category: 'creative',
    mode: 'dark',
    colors: {
      primary: '#FF6B9D',
      secondary: '#FEC6A1',
      background: 'linear-gradient(135deg, #1A1A2E 0%, #16213E 100%)',
      text: '#FFFFFF',
      textSecondary: '#C4B5FD',
      buttonBg: 'linear-gradient(90deg, #FF6B9D 0%, #FEC6A1 100%)',
      buttonText: '#1A1A2E',
      cardBg: '#0F3460',
      border: '#FF6B9D',
    },
    fonts: {
      heading: 'font-sans',
      body: 'font-sans',
    },
    styles: {
      cardRadius: '16px',
      buttonRadius: '8px',
      buttonStyle: 'gradient',
    },
  },
  {
    id: 'creative-pastel',
    name: 'Pastel Dream',
    category: 'creative',
    mode: 'light',
    colors: {
      primary: '#A78BFA',
      secondary: '#F472B6',
      background: 'linear-gradient(135deg, #FDE1D3 0%, #F6D5F7 50%, #C7EBFF 100%)',
      text: '#5B21B6',
      textSecondary: '#7C3AED',
      buttonBg: 'linear-gradient(90deg, #A78BFA 0%, #F472B6 100%)',
      buttonText: '#FFFFFF',
      cardBg: 'rgba(255,255,255,0.8)',
      border: '#A78BFA',
    },
    fonts: {
      heading: 'font-sans',
      body: 'font-sans',
    },
    styles: {
      cardRadius: '24px',
      buttonRadius: '20px',
      buttonStyle: 'gradient',
    },
  },
  // 🆕 PREMIUM THEMES (16-20)
  {
    id: 'premium-frosted',
    name: 'Frosted Glass Pro',
    category: 'premium',
    mode: 'light',
    colors: {
      primary: '#06B6D4',
      secondary: '#0891B2',
      accent: '#22D3EE',
      background: 'linear-gradient(135deg, #E0F2FE 0%, #BAE6FD 50%, #7DD3FC 100%)',
      text: '#0C4A6E',
      textSecondary: '#0369A1',
      buttonBg: 'rgba(255,255,255,0.4)',
      buttonText: '#0C4A6E',
      cardBg: 'rgba(255,255,255,0.5)',
      border: 'rgba(255,255,255,0.6)',
    },
    fonts: {
      heading: 'font-sans',
      body: 'font-sans',
    },
    styles: {
      cardRadius: '28px',
      buttonRadius: '16px',
      buttonStyle: 'solid',
      backgroundPattern: 'backdrop-blur-2xl',
    },
  },
  {
    id: 'premium-luxury',
    name: 'Luxury Black & Gold',
    category: 'premium',
    mode: 'dark',
    colors: {
      primary: '#D4AF37',
      secondary: '#FFD700',
      accent: '#FDB931',
      background: '#0A0A0A',
      text: '#FFFFFF',
      textSecondary: '#D4AF37',
      buttonBg: '#D4AF37',
      buttonText: '#0A0A0A',
      cardBg: '#1A1A1A',
      border: '#D4AF37',
    },
    fonts: {
      heading: 'font-serif',
      body: 'font-sans',
    },
    styles: {
      cardRadius: '16px',
      buttonRadius: '8px',
      buttonStyle: 'solid',
    },
  },
  {
    id: 'premium-aurora',
    name: 'Aurora Gradient',
    category: 'premium',
    mode: 'dark',
    colors: {
      primary: '#00FFF0',
      secondary: '#7B68EE',
      accent: '#00FF87',
      background: 'linear-gradient(135deg, #0F2027 0%, #203A43 50%, #2C5364 100%)',
      text: '#FFFFFF',
      textSecondary: '#A0E7E5',
      buttonBg: 'linear-gradient(135deg, #00FFF0 0%, #7B68EE 50%, #00FF87 100%)',
      buttonText: '#0F2027',
      cardBg: 'linear-gradient(135deg, rgba(15,32,39,0.9) 0%, rgba(32,58,67,0.9) 50%, rgba(44,83,100,0.9) 100%)',
      border: 'rgba(0,255,240,0.3)',
    },
    fonts: {
      heading: 'font-sans',
      body: 'font-sans',
    },
    styles: {
      cardRadius: '24px',
      buttonRadius: '12px',
      buttonStyle: 'gradient',
    },
  },
  {
    id: 'premium-eco',
    name: 'Eco Green Minimal',
    category: 'premium',
    mode: 'light',
    colors: {
      primary: '#059669',
      secondary: '#10B981',
      accent: '#34D399',
      background: 'linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%)',
      text: '#064E3B',
      textSecondary: '#047857',
      buttonBg: '#059669',
      buttonText: '#FFFFFF',
      cardBg: '#FFFFFF',
      border: '#A7F3D0',
    },
    fonts: {
      heading: 'font-sans',
      body: 'font-sans',
    },
    styles: {
      cardRadius: '20px',
      buttonRadius: '12px',
      buttonStyle: 'solid',
    },
  },
  {
    id: 'premium-cyber',
    name: 'Cyber Neon Dark',
    category: 'premium',
    mode: 'dark',
    colors: {
      primary: '#00FFFF',
      secondary: '#FF00FF',
      accent: '#00FF00',
      background: '#000000',
      text: '#00FFFF',
      textSecondary: '#FF00FF',
      buttonBg: 'rgba(0,255,255,0.2)',
      buttonText: '#00FFFF',
      cardBg: '#050505',
      border: '#00FFFF',
    },
    fonts: {
      heading: 'font-mono',
      body: 'font-mono',
    },
    styles: {
      cardRadius: '8px',
      buttonRadius: '4px',
      buttonStyle: 'outline',
    },
  },
];